<script>
import Paging from "@/components/Paging";
import Api from "api-client";
import {getCurrencies} from "@/cache";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/hu";

export default {
  name: "CostsSummary",
  components: {ToggleSwitch, Paging, DatePicker,},

  data() {
    return {
      sessionStorageKey: 'costsSummaryFilters',
      currencies: undefined,
      result: {},
      rowIdToEdit: -1,
      searchTerm: "",
      isNavOpened: false,
      isUploadOpened: false,

      navPopoverContent: '<div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #B2EC5D; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-link"></i></div>NAV összerendelés megtalálható</div></div><div><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #F88278; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-link"></i></div>NAV összerendelés hiányzik</div></div>',
      uploadPopoverContent: '<div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #B2EC5D; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-upload"></i></div>Feltöltött fájl megtalálható</div></div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #F88278; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-upload"></i></div>Feltöltött fájl hiányzik</div><div><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #E5EAEE; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-upload"></i></div>Feltöltött fájl hiányzik, de nincs is rá szükség</div></div>',
      showInfoModal: false,
      toBeDoneFilter: false,
      invoiceNumberFilter: "",
      filtersOpen: true,
      dateValueFilter: "",
      toBeAccountedFilter: false,
      processStatus: {},
      processStatusInterval: null,
      processStatusIntervalCounter: 0,
      showRefreshButton: false,
      currentPage: 0,
      currentPageSize: 10,
      isRestoringState: false,

      settleFilter: undefined,
      settleFilterOptions: [
        {text: "összes", value: undefined},
        {text: "elszámolom", value: "TO_BE_ACCOUNTED"},
        {text: "nem számolom el", value: "NOT_TO_BE_ACCOUNTED"},
      ],

      tourOptions: {
        useKeyboardNavigation: true,
        highlight: true,
        labels: {
          buttonSkip: 'x',
          buttonPrevious: '<',
          buttonNext: '>',
          buttonStop: 'x'
        },
      },
      steps: [
        {
          target: '#costs_g1',
          content: 'Itt kereshetsz a szállítók nevére',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g2',
          content: 'A gomb megnyomásával további szűrőket érhetsz el.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g3',
          content: 'A számlaszám mellett a tárgyidőszakra, státuszra és az elszámolandó számlákra is tudsz külön szűrni.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g4',
          content: 'Itt a feltöltött számláid státuszát tudod követni.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g5',
          content: 'Első pontban a feltöltés alatt lévő számláidszámosságát.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g6',
          content: 'A másodikban a feldolgozás alatt álló számláidat tekintheted meg',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g7',
          content: 'Ez a blokk a párosítás alatt álló számláidat mutatja. ',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g8',
          content: 'Amennyiben minden üresen látod akkor minden feltöltött számlád párosítása kész és elérhető a számlaösszesítőben.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g9',
          content: 'Amennyiben minden üresen látod akkor minden feltöltött számlád párosítása kész és elérhető a számlaösszesítőben.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#costs_g10_1',
          content: 'A teljes sorra kattintva részletesen is megtekintheted az adott számládat.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g-last',
          content: 'Ha segítségre van szükséged ezt súgót bármikor elérheted az ikonra kattintva.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        }
      ],
    };
  },

  props: {
    companyId: {
      required: true,
      type: Number,
    },
    isInbound: {
      required: true,
      type: Boolean,
      default: false
    },
  },

  async mounted() {
    this.currencies = JSON.parse(await getCurrencies());
    document.addEventListener('click', this.closeAllPopovers, true);

    // Initialize process status and set up polling
    this.fetchProcessStatus();
    this.startProcessStatusInterval();

    if (!document.cookie.includes('costSummaryGuideDisabled=true')) {
      // this.$tours['costSummaryGuide'].start();
    }
  },

  computed: {
    tourCallbacks() {
      return {
        onSkip: this.onTourFinish,
        onStop: this.onTourFinish,
        onFinish: this.onTourFinish,
      };
    },
  },

  methods: {

    onTourFinish() {
      const d = new Date();
      d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = "costSummaryGuideDisabled=true;" + expires + ";path=/";
    },

    fetchProcessStatus() {
      Api.aiProcessStatus(this.companyId)
          .then((resp) => (this.processStatus = resp.data))
          .catch((error) => {
            console.error("API hiba:", error);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: error.data.message,
            });
          });
    },

    startProcessStatusInterval() {
      this.showRefreshButton = false;
      this.processStatusIntervalCounter = 0;
      this.processStatusInterval = setInterval(() => {
        if (this.processStatusIntervalCounter >= 20) {
          clearInterval(this.processStatusInterval);
          this.showRefreshButton = true;
          return;
        }
        this.fetchProcessStatus();
        this.processStatusIntervalCounter++;
      }, 20000);
    },

    redirectToDetailView(digestId) {
      this.$router.push("document/" + digestId);
    },

    navigateToUpload() {
      this.$router.push({
        path: 'costs/fileUpload?resourceType=EXPENSE',
      });
    },

    doPage(data) {
      this.currentPage = data.pagingPage - 1;
      this.currentPageSize = data.pagingOffset;
      this.saveFiltersToSessionStorage();
      this.loadData(data.pagingPage - 1, data.pagingOffset);
    },

    loadData(page, size) {
      this.currentPage = page;
      this.currentPageSize = size;
      this.saveFiltersToSessionStorage();

      // convert date filter toYYYY-MM-01
      let formattedDateValue = "";
      if (this.dateValueFilter && this.dateValueFilter instanceof Date) {
        const year = this.dateValueFilter.getFullYear();
        const month = String(this.dateValueFilter.getMonth() + 1).padStart(2, '0');
        formattedDateValue = `${year}-${month}-01`;
      } else if (typeof this.dateValueFilter === 'string') {
        formattedDateValue = this.dateValueFilter;
      }

      Api.getInvoicesOfCompany(
          'EXPENSE',
          page,
          size,
          this.companyId,
          this.searchTerm || "",
          this.toBeAccountedFilter ? "TO_BE_ACCOUNTED" : undefined,
          this.invoiceNumberFilter || "",
          this.toBeDoneFilter === true,
          formattedDateValue
      )
          .then((resp) => (this.result = resp.data))
          .catch((error) => {
            console.error("API hiba:", error);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    },

    toggleToBeAccounted(id, value) {
      Api.toggleToBeAccounted(
          id,
          value,
      )
          .then(() => {
                this.loadData(
                    this.result.pageable.pageNumber,
                    this.result.pageable.pageSize
                )
              }
          )
    },

    convertCurrency(currency) {
      switch (currency) {
        case 'Ft':
          return 'HUF';
        case 'ft':
          return 'HUF';
        default:
          return currency;
      }
    },

    closeAllPopovers(event) {
      // Only close if the click is outside any popover-trigger button
      if (!event.target.closest('[v-b-popover]')) {
        this.$root.$emit('bv::hide::popover');
      }
    },

    toggleFilters() {
      this.filtersOpen = !this.filtersOpen;
    },

    saveFiltersToSessionStorage() {
      let dateValue = null;
      if (this.dateValueFilter instanceof Date) {
        dateValue = this.dateValueFilter.toISOString();
      } else if (typeof this.dateValueFilter === 'string' && this.dateValueFilter) {
        dateValue = this.dateValueFilter;
      }
      const filters = {
        searchTerm: this.searchTerm,
        invoiceNumberFilter: this.invoiceNumberFilter,
        dateValueFilter: dateValue,
        toBeAccountedFilter: this.toBeAccountedFilter,
        toBeDoneFilter: this.toBeDoneFilter,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
      };
      sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(filters));
    },

    restoreFiltersFromSessionStorage() {
      const stored = sessionStorage.getItem(this.sessionStorageKey);
      if (stored) {
        try {
          this.isRestoringState = true;
          const filters = JSON.parse(stored);
          if (filters.searchTerm !== undefined) this.searchTerm = filters.searchTerm;
          if (filters.invoiceNumberFilter !== undefined) this.invoiceNumberFilter = filters.invoiceNumberFilter;
          if (filters.dateValueFilter) this.dateValueFilter = new Date(filters.dateValueFilter);
          if (filters.toBeAccountedFilter !== undefined) this.toBeAccountedFilter = filters.toBeAccountedFilter;
          if (filters.toBeDoneFilter !== undefined) this.toBeDoneFilter = filters.toBeDoneFilter;
          if (filters.currentPage !== undefined) this.currentPage = filters.currentPage;
          if (filters.currentPageSize !== undefined) this.currentPageSize = filters.currentPageSize;
          // A flag-et a következő tick-ben állítjuk vissza, hogy a watcherek
          // (amelyek aszinkron módon futnak le a reaktív értékek változása után)
          // még lássák a true értéket és kihagyják a felesleges loadData hívást.
          // Enélkül race condition lép fel: a beforeMount loadData hívása és a
          // watcherek által indított loadData(0, ...) hívás versenyezne, és a
          // lapozó hibás oldalszámot mutatna a megjelenített adatokhoz képest.
          this.$nextTick(() => {
            this.isRestoringState = false;
          });
        } catch (e) {
          this.isRestoringState = false;
          console.error('Error restoring filters from session storage:', e);
        }
      }
    },
  },

  watch: {
    searchTerm() {
      if (this.isRestoringState) return;
      this.saveFiltersToSessionStorage();
      this.loadData(0, this.currentPageSize);
    },

    settleFilter() {
      if (this.isRestoringState) return;
      this.loadData(0, this.currentPageSize);
    },

    invoiceNumberFilter() {
      if (this.isRestoringState) return;
      this.saveFiltersToSessionStorage();
      this.loadData(0, this.currentPageSize);
    },

    toBeAccountedFilter() {
      if (this.isRestoringState) return;
      this.saveFiltersToSessionStorage();
      this.loadData(0, this.currentPageSize);
    },

    dateValueFilter() {
      if (this.isRestoringState) return;
      this.saveFiltersToSessionStorage();
      this.loadData(0, this.currentPageSize);
    },

    toBeDoneFilter() {
      if (this.isRestoringState) return;
      this.saveFiltersToSessionStorage();
      this.loadData(0, this.currentPageSize);
    },
  },

  beforeMount() {
    // Restore filters from session storage before loading data
    this.restoreFiltersFromSessionStorage();
    this.loadData(this.currentPage, this.currentPageSize);
  },

  beforeDestroy() {
    if (this.processStatusInterval) {
      clearInterval(this.processStatusInterval);
    }
    document.removeEventListener('click', this.closeAllPopovers, true);
  },
};
</script>

<template>
  <div class="CostsSummary_vue main-wrapper m-0 p-0 mt-3 font-jumperlight container-fluid">

    <button id="costs_g-last" @click="$tours['costSummaryGuide'].start()" class="startGuideBtn"><i
        class="fal fa-question-circle"></i></button>
    <v-tour
        name="costSummaryGuide"
        :steps="steps"
        :options="tourOptions"
        :callbacks="tourCallbacks"
    ></v-tour>

    <b-row class="mb-2 summaryFilters">
      <b-col cols="12">
        <div class="px-3" id="costs_g1">
          <b-form-input
              debounce="600"
              v-model="searchTerm"
              class="white-input d-inline-block align-middle"
              placeholder="Írd be a szállító nevét"
              style="width: calc(100% - 50px);"
          ></b-form-input>
          <button
              id="costs_g2"
              class="btn btn-link ml-2 align-items-center bg-white p-2 border rounded-circle shadow-lg"
              @click="toggleFilters"
              aria-label="Toggle filters"
              style="vertical-align: middle; font-size: 1rem; width: 40px; height: 40px; border-color: #CED4DA !important; margin-top: -10px;"
          >
            <i class="fa-light fa-sliders"></i>
          </button>
        </div>
        <transition name="accordion-slide">
          <div v-show="filtersOpen" class="formFilters mb-2 px-3 mr-0 mr-md-5" id="costs_g3">
            <b-row class="mb-2">
              <b-col class="col-12 col-md-6">
                <b-form-input v-model="invoiceNumberFilter" placeholder="Számlaszám" class="mb-2 white-input"/>
              </b-col>
              <b-col class="col-12 col-md-6">
                <date-picker
                    v-model="dateValueFilter"
                    :format="'YYYY-MM'"
                    placeholder="Tárgyidőszak"
                    type="month"
                    class="white-input mb-3 mb-md-0"
                    :clearable="true"
                    style="width: 100%;"
                />
              </b-col>
            </b-row>
            <b-row class="mb-1 px-3">
              <b-col>
                <div class="d-flex align-items-center">
                  <ToggleSwitch v-model="toBeAccountedFilter"/>
                  <div class="ml-2 mb-2 small">Elszámolom</div>
                </div>
              </b-col>
            </b-row>
            <b-row class="px-3">
              <b-col>
                <div class="d-flex align-items-center">
                  <ToggleSwitch v-model="toBeDoneFilter"/>
                  <span class="ml-2 mb-2 small">Beérkezésre vár</span></div>
              </b-col>
            </b-row>
          </div>
        </transition>
      </b-col>
    </b-row>

    <div id="costs_g9">
      <div v-if="processStatus"
           class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4 px-0 px-lg-5" id="costs_g4">

        <div v-if="showRefreshButton" class="col-12 text-center mb-4">
          <button @click="startProcessStatusInterval" class="btn btn-primary">Frissítés</button>
        </div>

        <div class="processCard col-6 col-lg-auto"
             :class="processStatus.queuedForProcessorUpload > 0 ? 'processActive' : ''" id="costs_g5">
          <div class="iconContainer">
            <i class="fa-light fa-upload"></i>
          </div>
          <div class="processCardContent">
            <div class="processCounter">
              <span v-if="processStatus.queuedForProcessorUpload">{{ processStatus.queuedForProcessorUpload }} db</span>
            </div>
            <div class="processText">Feltöltés</div>
          </div>
        </div>

        <div class="d-none d-lg-block">
          <i class="fa-light fa-chevron-right"></i>
        </div>

        <div class="processCard col-6 col-lg-auto" :class="processStatus.pending > 0 ? 'processActive' : ''" id="costs_g6">
          <div class="iconContainer">
            <i class="fa-light fa-arrow-progress"></i>
          </div>
          <div class="processCardContent">
            <div class="processCounter">
              <span v-if="processStatus.pending">{{ processStatus.pending }} db</span>
            </div>
            <div class="processText">Feldolgozás</div>
          </div>
        </div>

        <div class="d-none d-lg-block">
          <i class="fa-light fa-chevron-right"></i>
        </div>

        <div class="processCard col-6 col-lg-auto" :class="processStatus.waitingForDp > 0 ? 'processActive' : ''"
             id="costs_g7">
          <div class="iconContainer">
            <i class="fa-light fa-link"></i>
          </div>
          <div class="processCardContent">
            <div class="processCounter">
              <span v-if="processStatus.waitingForDp">{{ processStatus.waitingForDp }} db</span>
            </div>
            <div class="processText">Párosítás</div>
         </div>
       </div>
        <div class="d-none d-lg-block">
          <i class="fa-light fa-chevron-right"></i>
        </div>

        <div class="processCard col-6 col-lg-auto" id="costs_g8">
          <div class="iconContainer">
            <i class="fa-light fa-check"></i>
          </div>
          <div class="processCardContent">
            <div class="processCounter"></div>
            <div class="processText">Kész</div>
          </div>
        </div>

      </div>
    </div>

    <div v-if="result && result.totalNumberOfElements == 0" class="mx-3">Nincsenek megjeleníthető adatok</div>
    <div v-else class="mx-3" id="costs_g10_1">

      <div v-for="(item) in result.content"
           :key="item.id" :style="(item.toBeAccounted && !item.irrelevant) ? '' : 'opacity: 0.5;'">
        <b-row style="border-radius: 36px; background-color: #AEC0C7;" class="mb-3 p-2 p-lg-3 shadow-lg itemRow"
               :class="item.hasDocumentProcessorSource ? 'itemRowClickable' : ''"
               @click="item.hasDocumentProcessorSource ? redirectToDetailView(item.id) : null">
          <b-col class="col-md-4 col-12 d-flex flex-column align-items-start justify-content-center"
                 style="font-size: 15px;">
            <div class="mt-3 mt-lg-0">{{
                item.partnerName.lenght > 45 ? item.partnerName.substring(0, 45) + "..."
                    : item.partnerName
              }}
            </div>
            <div class="small text-muted">{{ item.invoiceNumber }}</div>
          </b-col>
          <b-col
              class="col-md-2 col-4 justify-content-start justify-content-lg-end text-left text-lg-right ml-3 ml-lg-0 mt-2 mt-lg-3 px-0 pr-3"
              style="font-size: 19px; line-height: 1.2;">
          <span class="text-nowrap">{{
              item.totalGrossAmount ? item.totalGrossAmount.toLocaleString('hu-HU') : '-'
            }} {{ convertCurrency(item.currency) }}</span>
          </b-col>
          <b-col class="col-md-1 col-2 justify-content-center text-center">
            <div v-if="item.foreignInvoice" v-b-tooltip title="Külföldi számla" class="pt-2 pt-md-3"><i
                class="fa-light fa-globe"></i></div>
          </b-col>
          <b-col
              class="col-md-1 col-12 justify-content-center justify-content-lg-center my-0 ml-3 ml-lg-0 my-lg-3 mt-3 mt-lg-0 px-0">
          <span class="border px-2 pt-2 pb-1 text-nowrap"
                style="border-radius: 18px; border-color: black !important; font-size: 13px;">{{
              item.dateTag.slice(0, -3)
            }}</span>
          </b-col>
          <b-col class="col-lg-4 col-12 mt-2 mt-lg-0">
            <b-row class="mb-2 mb-lg-0">
              <b-col class="col-5 text-left text-lg-right mt-3 mt-lg-2">
                <div class="d-inline-block text-center mr-1 pt-2"
                     style="font-size: 18px; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"
                     :style="item.toBeAccounted ? 'background-color: #B2EC5D' : 'background-color: #E5EAEE'"
                     :class="item.hasNavSource ? 'bgGreen' : 'bgRed'">
                  <button v-b-popover.html.top.click="navPopoverContent" class="btn btn-transparent p-0 m-0"
                          @click.stop><i
                      class="fal fa-link"></i></button>
                </div>
                <div
                    v-if="item.toBeAccounted && !item.hasDocumentProcessorSource"
                    class="d-inline-block text-center pt-2 bgRed"
                    style="font-size: 18px; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"
                >
                  <button @click.stop="navigateToUpload" class="btn btn-transparent p-0 m-0"><i
                      class="fal fa-upload"></i></button>
                </div>
                <div
                    v-if="item.toBeAccounted && item.hasDocumentProcessorSource"
                    class="d-inline-block text-center pt-2 bgGreen"
                    style="font-size: 18px; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"
                >
                  <button v-b-popover.html.top.click="uploadPopoverContent" class="btn btn-transparent p-0 m-0"
                          @click.stop><i
                      class="fal fa-upload"></i></button>
                </div>
                <div
                    v-if="!item.toBeAccounted && !item.hasDocumentProcessorSource"
                    class="d-inline-block text-center pt-2 bgGrey"
                    style="font-size: 18px; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"
                >
                  <button v-b-popover.html.top.click="uploadPopoverContent" class="btn btn-transparent p-0 m-0"
                          @click.stop><i
                      class="fal fa-upload"></i></button>
                </div>
              </b-col>
              <b-col cols="7" class="text-right">
                <div class="d-flex align-items-center justify-content-end">
                  <div class="mr-3 pt-2 small">Elszámolom</div>
                  <div class="pt-3">
                    <ToggleSwitch v-model="item.toBeAccounted"
                                  @change="() => toggleToBeAccounted(item.id, item.toBeAccounted)" @click.native.stop/>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

    </div>

    <paging
        v-if="result.totalNumberOfElements > 0"
        :page="currentPage + 1"
        :item-per-page="currentPageSize"
        :total-rows="result.totalNumberOfElements"
        @paging-change="doPage"
    />

  </div>
</template>

<style scoped>
.main-wrapper {
  background-color: white;
  padding: 15px;
  border-radius: 5px;

}

.red-icon {
  color: red;
}

.green-icon {
  color: #b2ec5d;
}

.search-icon {
  color: gray;
  font-size: 1.3rem;
}


.grayed-out {
  color: gray !important;
}

.customTable thead {
  font-size: 11px !important;
}

.popover {
  max-width: 350px !important;
  width: 450px !important;
  border-radius: 32px !important;
  padding: 14px;
}

button:focus {
  outline: none !important;
  box-shadow: none !important;
}

::v-deep .custom-modal-width {
  max-width: 800px !important;
  width: 800px !important;
}

@media (max-width: 768px) {
  ::v-deep .custom-modal-width {
    max-width: 96vw !important;
    width: 96vw !important;
  }
}

.bgGreen {
  background-color: #B2EC5D !important;
}

.bgRed {
  background-color: #F88278 !important;
}

.bgGrey {
  background-color: #E5EAEE !important;
}

.accordion-fade-enter-active, .accordion-fade-leave-active {
  transition: opacity 0.3s ease;
}

.accordion-fade-enter, .accordion-fade-leave-to {
  opacity: 0;
}

.accordion-slide-enter-active, .accordion-slide-leave-active {
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.accordion-slide-enter, .accordion-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.accordion-slide-enter-to, .accordion-slide-leave {
  max-height: 500px;
  opacity: 1;
}

::v-deep .mx-icon-calendar {
  display: none !important;
}

::v-deep .mx-input {
  margin-bottom: 0px !important;
}

.alert-info {
  background-color: #252734;
  color: white;
  border: none;
  border-radius: 32px;
}

::v-deep .alert-dismissible .close {
  margin: 21px !important;
}

.itemRowClickable {
  cursor: pointer;
}

.itemRowClickable:hover {
  margin-left: -20px !important;
  margin-right: -10px;
}

.processCard {
  margin-bottom: 10px;
  width: 20%;
}

.processCardContent {
  background-color: #aabdc4;
  border-radius: 18px;
  opacity: 0.3;
  margin-top: -50px;
  margin-left: 10px;
  padding: 15px 15px 5px 15px;
}

.iconContainer {
  background-color: #BDBEC2;
  color: white;
  border-radius: 32px;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 22px;
}

.processCounter {
  visibility: hidden;
  font-size: 20px;
  height: 40px;
}

.processText {
  font-size: 12px;
  padding: 10px 0px 10px 0px;
}

.processActive {
  .processCardContent {
    opacity: 0.8;
  }

  .iconContainer {
    background-color: #252734;
  }

  .processText {
    font-size: 16px;
    text-align: center;
    padding: 5px 0px 5px 0px;
  }

  .processCounter {
    visibility: visible;
    text-align: right;
  }
}

.startGuideBtn {
  position: relative;
  top: -132px;
  right: 50px;
  float: right;
  cursor: pointer;
  color: #252734;
  background-color: transparent;
  border-radius: 32px;
  border: none;
  width: 40px;
  height: 40px;
  z-index: 1050;
}

::v-deep .v-step__content {
  padding: 10px;
}

::v-deep .v-step {
  background-color: white !important;
  border-radius: 24px !important;
  border: 1px solid #B6C3C8;
  color: #202020;
}

::v-deep .v-step__buttons {
  text-align: right;
}

::v-deep .v-step__button {
  color: #202020 !important;
  border-radius: 24px !important;
  border: 1px solid #B6C3C8;
  padding: 0px 10px !important;
  font-size: 16px;
  width: 36px;
  height: 36px;
}

::v-deep .v-step__arrow {
  display: none;
}

::v-deep .v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(255, 255, 255, .9) !important;
  border-radius: 28px;
}
</style>
